/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import RequestAssetQuoteForm from './RequestAssetQuoteForm/RequestAssetQuoteForm';
import RequestAssetQuoteSuccess from './RequestAssetQuoteSuccess/RequestAssetQuoteSuccess';
import RequestAssetQuoteError from './RequestAssetQuoteError/RequestAssetQuoteError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class RequestAssetQuote extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const fields: Array<Object> = [
      {
        name: 'natureOfRequest',
        label: t('general:labels.nature_of_request'),
        fields: [
          {
            name: 'requestType',
            label: t('general:labels.nature_of_request'),
            rules: 'required|string',
            value: '',
            options: [
              {
                id: 'rental',
                label: t('general:reasons.options.interest_in_renting_asset'),
                value: false,
              },
              {
                id: 'new',
                label: t('general:reasons.options.interest_in_buying_new_asset'),
                value: false,
              },
              {
                id: 'used',
                label: t('general:reasons.options.interest_in_buying_used_asset'),
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: 'additionalInformation',
        label: t('general:labels.additional_info'),
        fields: [
          {
            name: 'quoteMessage',
            label: t('general:message'),
            rules: 'string',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { requestType }: Object = data.values().natureOfRequest;

        const { quoteMessage }: Object = data.values().additionalInformation;

        actionDrawerStore.requestAssetQuote(asset.id, {
          request_type: requestType,
          quote_message: quoteMessage,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'requestAssetQuote',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const title: string = t('general:actions.request_quote');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <RequestAssetQuoteError asset={asset} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <RequestAssetQuoteSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <RequestAssetQuoteForm asset={asset} form={this.createForm()} />
      </div>
    );
  }
}
